<template>
  <scroll-bar>
    <el-menu
      mode="vertical"
      :show-timeout="200"
      :default-active="$route.path"
      :collapse="isCollapse"
      background-color="#00423C"
      text-color="#bfcbd9"
      active-text-color="#409EFF"
    >
      <sidebar-item :routes="routes" :user="user"></sidebar-item>
    </el-menu>
  </scroll-bar>
</template>

<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'
import ScrollBar from '@/components/ScrollBar'

export default {
  components: { SidebarItem, ScrollBar },
  props: {
    user: null
  },
  computed: {
    ...mapGetters([
      'sidebar'
    ]),
    routes() {
      if(!this.user){
        return [];
      }
      let menu=require('@/config/menu');
      let loop = (data)=>{
        let result=[];
        data.forEach(item=>{
          if(item.items){
            result.push({
              name:item.name,
              icon:item.icon,
              items:loop(item.items)
            })
          }else{
            if(!item.permission || this.user.can(item.permission)){
              result.push(item);
            }
          }
        });
        return result;
      }
      return loop(menu);
    },
    isCollapse() {
      return !this.sidebar.opened
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/layout/components/Sidebar/index.vue